import { HomeFooter } from "homepage/homeFooter";
import { Header } from "homepage/homeHeader";
import React, { useEffect, useState } from "react";
import api from "services/api";
import "./privacyPolicy.css";

export const PrivacyPolicy = () => {
  return (
    <div className="home-page">
      <Header />
      <section className="network">
        <div className="container network-block">
          <div className="row">
            <div className="col-md-12 mb-5">
              <div className="network-content">
                <h1 className="main-title lh-70 text-center">
                  <span className="text-gradient privacy-main-title">
                    Privacy Policy
                  </span>
                  <br />
                </h1>
                <div className="title-slogan px-5 privacy-content">
                  <p className="privacy-body-text">
                    <strong>Effective Date:</strong> 11 April 2025
                  </p>
                  <p className="privacy-body-text">
                    <strong>Last Updated:</strong> 2 July 2025
                  </p>

                  <p className="privacy-body-text">
                    This Privacy Policy outlines how Zenosure Digital Private
                    Limited ("Zenosure", "we", "our", or "us") collects, uses,
                    shares, and protects your personal information through our
                    platform at www.zenosure.com.
                  </p>

                  <p className="privacy-body-text">
                    By accessing our website or using our services, you agree to
                    the practices described in this Privacy Policy.
                  </p>

                  <h5 className="privacy-section-heading">
                    1. Information We Collect
                  </h5>

                  <h5 className="privacy-subsection-heading">
                    A. Personal Information
                  </h5>

                  <p className="privacy-body-text">
                    We collect the following personal information during account
                    registration, cashback processing, or service use:
                  </p>
                  <ul className="privacy-list">
                    <li className="privacy-list-item">Full name</li>
                    <li className="privacy-list-item">Mobile number</li>
                    <li className="privacy-list-item">Email address</li>
                    <li className="privacy-list-item">Postal address</li>
                    <li className="privacy-list-item">
                      PAN and Aadhaar (for identity verification and compliance)
                    </li>
                    <li className="privacy-list-item">
                      Banking details for cashback transactions (e.g., account
                      number and IFSC)
                    </li>
                    <li className="privacy-list-item">
                      IP address and device information
                    </li>
                  </ul>

                  <p className="privacy-body-text">
                    <strong>Note:</strong> We do not collect or store any
                    health-related data or medical records from our users.
                  </p>

                  <h5 className="privacy-subsection-heading">
                    B. Non-Personal Information
                  </h5>

                  <p className="privacy-body-text">This includes:</p>
                  <ul className="privacy-list">
                    <li className="privacy-list-item">
                      Browser type and version
                    </li>
                    <li className="privacy-list-item">
                      Device type and operating system
                    </li>
                    <li className="privacy-list-item">IP address</li>
                    <li className="privacy-list-item">
                      Geographic location (approximate)
                    </li>
                    <li className="privacy-list-item">
                      Date/time stamps of your interaction
                    </li>
                    <li className="privacy-list-item">
                      Pages visited and usage duration
                    </li>
                  </ul>

                  <h5 className="privacy-section-heading">
                    2. Use of Information
                  </h5>

                  <p className="privacy-body-text">Your data is used to:</p>
                  <ul className="privacy-list">
                    <li className="privacy-list-item">
                      Register and manage your user account
                    </li>
                    <li className="privacy-list-item">
                      Facilitate cashback and subscription transactions
                    </li>
                    <li className="privacy-list-item">
                      Communicate transaction status and service updates
                    </li>
                    <li className="privacy-list-item">
                      Verify your identity and prevent fraud
                    </li>
                    <li className="privacy-list-item">
                      Comply with legal and regulatory obligations
                    </li>
                    <li className="privacy-list-item">
                      Analyze and improve our website performance
                    </li>
                    <li className="privacy-list-item">
                      Notify you of offers or service changes
                    </li>
                  </ul>

                  <h5 className="privacy-section-heading">
                    3. Sensitive Personal Data
                  </h5>

                  <p className="privacy-body-text">
                    Under Indian law, PAN and Aadhaar details are classified as
                    Sensitive Personal Data or Information (SPDI). We collect
                    and process this data solely for the following reasons:
                  </p>
                  <ul className="privacy-list">
                    <li className="privacy-list-item">
                      To confirm user identity
                    </li>
                    <li className="privacy-list-item">
                      To meet statutory and regulatory requirements (e.g., KYC)
                    </li>
                    <li className="privacy-list-item">
                      To prevent misuse and detect fraud
                    </li>
                  </ul>

                  <p className="privacy-body-text">
                    This information is encrypted, stored securely, and never
                    shared with third parties except:
                  </p>
                  <ul className="privacy-list">
                    <li className="privacy-list-item">
                      With your explicit consent
                    </li>
                    <li className="privacy-list-item">
                      With government or legal authorities upon lawful request
                    </li>
                    <li className="privacy-list-item">
                      With regulated service partners for compliance processing
                    </li>
                  </ul>

                  <p className="privacy-body-text">
                    You may withdraw consent at any time by contacting us,
                    although doing so may limit your access to certain services.
                  </p>

                  <h5 className="privacy-section-heading">
                    4. Cookies and Tracking Technologies
                  </h5>

                  <p className="privacy-body-text">
                    We use cookies and similar tools to enhance your browsing
                    experience.
                  </p>

                  <h5 className="privacy-subsection-heading">
                    A. Types of Cookies Used
                  </h5>
                  <ul className="privacy-list">
                    <li className="privacy-list-item">
                      <strong>Essential Cookies:</strong> Required for
                      login/session management
                    </li>
                    <li className="privacy-list-item">
                      <strong>Performance Cookies:</strong> Track user behavior
                      for analytics
                    </li>
                    <li className="privacy-list-item">
                      <strong>Functionality Cookies:</strong> Save preferences
                      like language or layout
                    </li>
                    <li className="privacy-list-item">
                      <strong>Marketing Cookies:</strong> Personalize promotions
                      (minimal use)
                    </li>
                  </ul>

                  <p className="privacy-body-text">
                    You can disable cookies via browser settings; however,
                    essential cookies may be required for the platform to
                    function correctly.
                  </p>

                  <h5 className="privacy-section-heading">
                    5. Data Sharing and Disclosure
                  </h5>

                  <p className="privacy-body-text">
                    We do not sell your personal information.
                  </p>

                  <p className="privacy-body-text">
                    We may share data only with:
                  </p>
                  <ul className="privacy-list">
                    <li className="privacy-list-item">
                      Our affiliate partners to validate cashback claims
                    </li>
                    <li className="privacy-list-item">
                      Payment gateway providers to process transactions
                    </li>
                    <li className="privacy-list-item">
                      Government authorities, upon legal request
                    </li>
                    <li className="privacy-list-item">
                      Technology partners for infrastructure support (under NDA)
                    </li>
                  </ul>

                  <p className="privacy-body-text">
                    All third-party partners are expected to follow equivalent
                    data protection standards.
                  </p>

                  <h5 className="privacy-section-heading">
                    6. User Rights and Choices
                  </h5>

                  <p className="privacy-body-text">You have the right to:</p>
                  <ul className="privacy-list">
                    <li className="privacy-list-item">
                      Access the personal data we hold about you
                    </li>
                    <li className="privacy-list-item">
                      Request corrections to incorrect or outdated information
                    </li>
                    <li className="privacy-list-item">
                      Request deletion of your account and associated data
                    </li>
                    <li className="privacy-list-item">
                      Withdraw consent for marketing communications
                    </li>
                    <li className="privacy-list-item">
                      File a complaint with our Grievance Officer
                    </li>
                  </ul>

                  <p className="privacy-body-text">
                    To exercise your rights, please contact:{" "}
                    <strong>support@zenosure.com</strong>
                  </p>

                  <h5 className="privacy-section-heading">7. Data Retention</h5>

                  <p className="privacy-body-text">We retain your data:</p>
                  <ul className="privacy-list">
                    <li className="privacy-list-item">
                      As long as your account remains active
                    </li>
                    <li className="privacy-list-item">
                      For a minimum of 12 months post-inactivity (for legal and
                      audit compliance)
                    </li>
                    <li className="privacy-list-item">
                      For up to 7 years if required by financial regulatory
                      frameworks
                    </li>
                  </ul>

                  <p className="privacy-body-text">
                    Once data is no longer required, we securely erase or
                    anonymize it.
                  </p>

                  <h5 className="privacy-section-heading">8. Data Security</h5>

                  <p className="privacy-body-text">
                    We implement strict technical and organizational measures
                    including:
                  </p>
                  <ul className="privacy-list">
                    <li className="privacy-list-item">
                      Secure Sockets Layer (SSL) encryption
                    </li>
                    <li className="privacy-list-item">
                      Two-factor authentication for access control
                    </li>
                    <li className="privacy-list-item">
                      Regular security audits
                    </li>
                    <li className="privacy-list-item">
                      Access limitation to authorised personnel only
                    </li>
                  </ul>

                  <p className="privacy-body-text">
                    Despite best practices, no system can be guaranteed 100%
                    secure.
                  </p>

                  <h5 className="privacy-section-heading">
                    9. Consent Management and Withdrawal
                  </h5>

                  <p className="privacy-body-text">
                    When you register, you provide consent to:
                  </p>
                  <ul className="privacy-list">
                    <li className="privacy-list-item">
                      Our collection and processing of personal and sensitive
                      data
                    </li>
                    <li className="privacy-list-item">
                      Contact via email/SMS regarding service use
                    </li>
                  </ul>

                  <p className="privacy-body-text">
                    You may withdraw consent by emailing{" "}
                    <strong>support@zenosure.com</strong>. Your request will be
                    processed within 30 working days.
                  </p>

                  <h5 className="privacy-section-heading">
                    10. Third-Party Links
                  </h5>

                  <p className="privacy-body-text">
                    Our website may contain links to other websites (e.g.,
                    partner offers or payment gateways). We are not responsible
                    for the privacy practices or content on those websites.
                    Please read their policies separately before proceeding.
                  </p>

                  <h5 className="privacy-section-heading">
                    11. Children's Privacy
                  </h5>

                  <p className="privacy-body-text">
                    Our services are not intended for individuals under the age
                    of 18. If we discover a user is a minor, we will delete the
                    account and associated data.
                  </p>

                  <h5 className="privacy-section-heading">
                    12. Grievance Redressal
                  </h5>

                  <p className="privacy-body-text">
                    We are committed to resolving your concerns promptly and
                    transparently.
                  </p>

                  <p className="privacy-body-text">
                    <strong>Grievance Contact Email:</strong>
                    <br />
                    <strong>support@zenosure.com</strong>
                  </p>

                  <p className="privacy-body-text">
                    Complaints will be acknowledged within 72 hours and resolved
                    within 30 days.
                  </p>

                  <h5 className="privacy-section-heading">
                    13. Governing Law and Jurisdiction
                  </h5>

                  <p className="privacy-body-text">
                    This Privacy Policy is governed by the laws of India,
                    particularly:
                  </p>
                  <ul className="privacy-list">
                    <li className="privacy-list-item">
                      Information Technology Act, 2000
                    </li>
                    <li className="privacy-list-item">SPDI Rules, 2011</li>
                  </ul>

                  <p className="privacy-body-text">
                    Disputes are subject to arbitration under the Indian
                    Arbitration and Conciliation Act, 1996, with jurisdiction in
                    Bangalore, Karnataka.
                  </p>

                  <h5 className="privacy-section-heading">
                    14. Changes to This Policy
                  </h5>

                  <p className="privacy-body-text">
                    We may update this Privacy Policy from time to time. Updates
                    will be notified via:
                  </p>
                  <ul className="privacy-list">
                    <li className="privacy-list-item">Website pop-ups</li>
                    <li className="privacy-list-item">
                      Registered email addresses
                    </li>
                  </ul>

                  <p className="privacy-body-text">
                    Your continued use after any update implies acceptance of
                    the revised policy.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <HomeFooter />
    </div>
  );
};
